<template>
    <div>

        <el-form label-position="top">

            <el-tabs type="border-card" v-model="tabAtivo">
                <el-tab-pane label="FILTROS" name="filtros">

                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="12" :md="12">
                                <el-form-item label="Instituição" key="instituicao" v-if="$store.state.user.tipo == 10 || ($store.state.user.tipo > 3 && $store.state.user.tipo <= 8)">
                                    <el-select ref="instituicao_id" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição" clearable @change="onChangeInstituicao" >
                                        <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <div class="style-form" v-if="$store.state.user.tipo <=3 || $store.state.user.tipo == 9">
                                    <label>Instituição</label>
                                    <div class="style-input readonly">{{ $store.state.config.instituicao.nome }}</div>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="6" :md="6">
                                <el-form-item label="Período" key="periodo">
                                    <el-select ref="periodo_letivo_id" v-model="filtro.periodo_letivo_id">
                                        <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="6" :md="6">
                                    <el-form-item label="Apresentação dos Dados" prop="apresentacao_dados" key="apresentacao_dados">
                                        <el-select ref="apresentacao_dados" v-model="filtro.apresentacao_dados">
                                            <el-option key="1" label="ENTURMADOS" :value="1"></el-option>
                                            <el-option key="2" label="LOTADOS" :value="2"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                        </el-row>

                        <el-row :gutter="10">
                                <el-col :xs="24" :sm="18" :md="18">
                                    <el-form-item label="Servidor" prop="servidor_id" key="servidor_id">
                                        <el-select v-model="filtro.servidor_id" placeholder="pesquisar..." filterable clearable remote :remote-method="getServidorByFilter" :loading="loadingServidor">
                                            <el-option v-for="item in servidores" :key="item.id" :label="item.nome" :value="item.id"> </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :xs="24" :sm="6" :md="6">
                                <el-form-item label="Turma" prop="turmas" key="turmas">
                                    <el-select v-model="filtro.turmaSelected" filterable clearable multiple>
                                        <el-option v-for="item in turmas" :key="item.id" :label="item.nome" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>                                
                            </el-row>                      

                </el-tab-pane>
                <el-tab-pane label="CAMPOS" name="campos">

                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="12" :md="12">
                                <label class="u-pl-5 u-mb-5" style="display: block; font-size: 15px;"><b>Campos do Servidor</b></label>
                                <div style="height: 260px; background-color: #f8f8f8; padding:10px;">
                                    <el-checkbox-group v-model="campos.servidor" class="checkbox-filtos">
                                        <el-checkbox label="nome">Nome do Servidor</el-checkbox>
                                        <el-checkbox label="cpf">CPF</el-checkbox>
                                        <el-checkbox label="contato">Contato</el-checkbox>
                                        <el-checkbox label="email">e-mail</el-checkbox>
                                        <el-checkbox label="escolaridade">Escolaridade</el-checkbox>
                                        <el-checkbox label="funcao">Função</el-checkbox>
                                        <el-checkbox label="logradouro">Logradouro</el-checkbox>
                                        <el-checkbox label="numero">Número</el-checkbox>
                                        <el-checkbox label="bairro">Bairro</el-checkbox>                                        
                                    </el-checkbox-group>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="12">
                                <label class="u-pl-5 u-mb-5" style="display: block; font-size: 15px;"><b>Campos da Enturmação</b></label>
                                <div style="height: 260px; background-color: #f8f8f8; padding:10px;">
                                    <el-checkbox-group v-model="campos.turma" class="checkbox-filtos">
                                        <el-checkbox label="nome">Turma</el-checkbox>
                                        <el-checkbox label="curso">Modalidade</el-checkbox>
                                        <el-checkbox label="area_conhecimento">Disciplina</el-checkbox>                                                                               
                                    </el-checkbox-group>
                                </div>
                            </el-col>
                        </el-row>


                </el-tab-pane>
            </el-tabs>

            <div class="u-mt-10">
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                        <!-- <el-button @click="getDadosRelatorioGeralServidor()" type="primary">BUSCAR</el-button>                     -->
                        <el-button @click="renderRelatorioGeralServidor('excel')" :loading="loadingButtonExcel" type="primary">EXCEL</el-button>
                        <el-button @click="renderRelatorioGeralServidor('pdf')" :loading="loadingButtonPdf" type="primary">PDF</el-button>
                        <el-button @click="renderRelatorioGeralServidor('html')" :loading="loadingButtonHtml" type="primary">HTML</el-button>
                        <el-button @click="renderRelatorioGeralServidor('word')" :loading="loadingButtonWord" type="primary">WORD</el-button>
                        <el-button @click="renderRelatorioGeralServidor('json')" :loading="loadingButtonJson" type="primary">JSON</el-button>
                    </el-col>
                </el-row>
            </div>


        </el-form>

    </div>
</template>
<script>
import cPanel from '../../../shared/c-panel/c-panel.vue';

export default {
  components: { cPanel },
    data: () => ({
        tabAtivo: 'filtros',
        loadingButtonExcel: false,
        loadingButtonPdf: false,
        loadingButtonHtml: false,
        loadingButtonWord: false,
        loadingButtonJson: false,
        loadingServidor: false,
        statusList: true,
        ref: [],  
        servidor_id: '',   
        servidores: [],   
        campos:{
            servidor: [
            'nome',
            'cpf',
            'email'
            ],
            turma: [
                'nome',
                'curso'
            ]        
        },
        filtro: {
            servidor_id: '',
            instituicao_id: '',
            periodo_letivo_id: '',
            turmaSelected: [],
            apresentacao_dados: 1
        },
        paginate: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        turmas: [],
        itens: []
        

    }),
    mounted () {

        this.filtro.periodo_letivo_id = this.$store.state.config.periodo.id;

        if(this.$store.state.user.tipo <=3 || this.$store.state.user.tipo == 9){

            this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
        }
        
    },
    methods: {
        onChangeInstituicao(valor){

            if (!valor) {
                this.turmas = [];
                this.filtro.turmaSelected = [];
                return;
            }

            this.getAllTurmas();
        },
        renderRelatorioGeralServidor(tipo){

            if(this.campos.servidor.length == 0){

                window.eventBus.$emit('alert', {msg: 'É necessário selecionar, pelo menos, um campo a ser apresentado no relatório.', type: 'warning'});
                return false;
            }

            this.ref = [
                { nome: 'Instituição', valor: ((this.$store.state.user.tipo <=3 || this.$store.state.user.tipo == 9) ? this.$store.state.config.instituicao.nome : this.$refs.instituicao_id.selected.label) },
                { nome: 'Período Letivo', valor: this.$refs.periodo_letivo_id.selected.label },
                { nome: 'Apresentação dos dados', valor: this.$refs.apresentacao_dados.selected.label },                
            ];
           

            if(tipo == 'pdf'){

                this.loadingButtonPdf = true;
                this.renderPdfRelatorioGeralServidor();

            }else if(tipo == 'html'){

                this.loadingButtonHtml = true;
                this.renderHtmlRelatorioGeralServidor();

            }else if(tipo == 'excel'){

                this.loadingButtonExcel = true;
                this.renderExcelRelatorioGeralServidor();
            }else if(tipo == 'word'){

                this.loadingButtonWord = true;
                this.renderWordRelatorioGeralServidor();
            }else if(tipo == 'json'){

                this.loadingButtonJson = true;
                this.renderJsonRelatorioGeralServidor();
            }
        },
        renderPdfRelatorioGeralServidor(){

            window.eventBus.$emit('print', {url: '/api/pdf/renderRelatorioGeralServidor/pdf', param: {ref: this.ref, filtros: this.filtro, campos: this.campos}});
            this.loadingButtonPdf = false;
        },
        renderExcelRelatorioGeralServidor(){

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pdf/renderRelatorioGeralServidor/excel`, { param: {ref: this.ref, filtros: this.filtro, campos: this.campos} }, this.$store.getters.getHeaderAuthExcel).then(response => {

                this.loadingButtonExcel = false;

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'relatorio.xlsx');
                document.body.appendChild(link);
                link.click();

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        renderWordRelatorioGeralServidor(){

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pdf/renderRelatorioGeralServidor/word`, { param: {ref: this.ref, filtros: this.filtro, campos: this.campos} }, this.$store.getters.getHeaderAuthExcel).then(response => {

                this.loadingButtonWord = false;

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'relatorio.docx');
                document.body.appendChild(link);
                link.click();

            }).catch((error) => { this.loadingButtonWord = false; this.$store.commit('throwException', error); });
        },
        renderJsonRelatorioGeralServidor(){

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pdf/renderRelatorioGeralServidor/json`, { param: {ref: this.ref, filtros: this.filtro, campos: this.campos} }, this.$store.getters.getHeaderAuthExcel).then(response => {

                this.loadingButtonJson = false;

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'relatorio.json');
                document.body.appendChild(link);
                link.click();

            }).catch((error) => { this.loadingButtonJson = false; this.$store.commit('throwException', error); });
        },
        async renderHtmlRelatorioGeralServidor(){   

            try{

                let response = await this.getCodAutorizacaoRelatorioHtml();

                window.open(`${process.env.VUE_APP_BASE_URL}/api/relatorio/open/${response.data.token}`);

                this.loadingButtonHtml = false;

            }catch(e){

                window.eventBus.$emit('alert', {msg: 'Erro ao gerar relatório.', type: 'warning'});
            }

        },
        getCodAutorizacaoRelatorioHtml(){

            return this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/relatorio/generateCodAutorizacaoPrintHtml/geral-servidor`, {ref: this.ref, filtros: this.filtro, campos: this.campos}, this.$store.getters.getHeaderAuth);
        },
        getAllTurmas(){

            this.turmas = [];
            this.filtro.turmaSelected = [];           
            
            let i = this.filtro.instituicao_id;
            let p = this.filtro.periodo_letivo_id;

            if (!i || !p) return;

            window.eventBus.$emit('loading', true);

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getAllTurmas/${i}/${p}`, this.$store.getters.getHeaderAuth).then(response => {

               this.turmas = Object.values(response.data)
                                   .flat()
                                   .sort((a, b) => a.nome.localeCompare(b.nome));               
               
               window.eventBus.$emit('loading', false);

            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        getServidorByFilter(query){

            if (query.length < 4){
            
                this.servidores = [];
                return false;
            }

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/servidor/searchByNome`, {query: query}, this.$store.getters.getHeaderAuth).then(response => {
            
                this.servidores = JSON.parse(JSON.stringify(response.data));
            
            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getPagePagination(page){
          this.paginate.page = page;
          this.getDadosRelatorioGeralServidor();
        },
        formatData(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA

            if(!this.filtro[field])
                return false;

            if(size && this.filtro[field].length < size)
                this.filtro[field] = '';

            this.filtro[field] = this.filtro[field].toUpperCase();

            this.filtro[field] = this.$removerAcentos(this.filtro[field]);
        },
        getSelected(v){

            let t = '';
            for(let i in v){

                t += ' ' + v[i].label;
            }
            return t;
        },
        addMultipleSelectFieldToRefFilter(name, valuesSelected){
            const temp = { nome: name, valor: [] }
            valuesSelected.forEach(element => {
                temp.valor.push(element.currentLabel);
            });
            this.ref.push(temp);
        }
    }
}
</script>